var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-icon-container"},[(_vm.isApp)?_c('image',{staticClass:"common-icon",style:({ width: _vm.props.width, height: _vm.props.height }),attrs:{"src":_vm.props.src}}):_c('img',{staticClass:"common-icon",style:({ width: _vm.props.width, height: _vm.props.height }),attrs:{"src":_vm.props.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }